module.exports = __webpack_public_path__ + "static/media/position.2d9eb2b7.svg";